import { cn } from '@/lib/utils';
import { X } from 'lucide-react';
import { FC, PropsWithChildren, ReactNode } from 'react';

interface DialogProps {
  onClose: () => void;
  /** Matn yoki tugun — masalan sarlavha oldiga tugma qo'yish uchun. */
  title: ReactNode;
  size?: 'sm' | 'default' | 'lg' | 'xl' | 'full';
  className?: string;
}

export const Dialog: FC<PropsWithChildren<DialogProps>> = ({
  onClose,
  title,
  size = 'default',
  children,
  className,
}) => {
  const contentClasess = cn(
    {
      ['max-w-sm']: size === 'sm',
      ['max-w-lg']: size === 'default',
      ['max-w-2xl']: size === 'lg',
      ['max-w-[60%]']: size === 'xl',
      ['max-w-screen h-screen']: size === 'full',
    },
    'w-full flex items-center justify-center',
  );

  return (
    <div
      className="fixed inset-0 z-[101] flex items-center justify-center bg-black/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
      onClick={onClose}
    >
      <div
        className={cn(contentClasess, className, 'dialog-container')}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative flex max-h-[calc(100vh-40px)] w-full flex-col overflow-y-auto rounded-2xl border border-border bg-[#111115] p-4 shadow-lg duration-200">
          <div className="flex items-center justify-between gap-x-5">
            <div className="flex items-center gap-3 text-lg font-semibold text-foreground">
              {title}
            </div>
            <button
              className="bg-whitesmoke rounded-full p-1.5"
              onClick={onClose}
            >
              <X className="h-[14px] w-[14px] text-foreground" />
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};
